module.exports = __webpack_public_path__ + "img/甘肃文旅_04.6712a140.jpg";